// extracted by mini-css-extract-plugin
export default {"page":"AN","top_block":"BN","heading":"CN","inner_text":"EN","starter_text":"FN","starter_cta":"GN","summary_block":"HN","cartsummary_wrap":"IN","price":"JN","pricing_wrap":"KN","summary_block_mob":"LN","summary":"MN","pricing_heading":"NN","products_summary":"ON","summary_line":"PN","summary_price":"QN","summary_title":"RN"};
    if(module.hot) {
      // 1713809678808
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  